import templateUrl from './sidebar.html';
import findIndex from 'lodash/findIndex';

export const sidebarComponent = {
	templateUrl,

	bindings: {
		list: '<',
		isSidebarOpen: '='
	},

	controller: class SidebarComponent {
		constructor($state, $transitions, BreadcrumbService) {
			'ngInject';
			this.$state = $state;
			this.fetaures = [];
			this.breadcrumbService = BreadcrumbService;
			this.onStateChangeSuccess.call(this);
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		onStateChangeSuccess() {
			this.featureArray = this.getFeatureArray(this.$state.current);
			this.featureName = this.featureArray.length > 0 ? this.featureArray[0]: 'dashboard';
			this.fetaures = [];
		}

		getFeatureArray(currentName) {
			let state = this.$state.get(currentName);
			if(state && state.name != 'app.dashboard') {
				this.fetaures.unshift(state.breadcrumbName);
				this.getFeatureArray(state.parentState);
			}
			return this.fetaures;
		}

		isMenuActive(name) {
			const breadcrumbs = this.breadcrumbService.breadcrumbs;
			const index = findIndex(breadcrumbs,{name});
			
			return index === -1 ? false : true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/sidebar/sidebar.component.js